import { List as AccountsCustomersList } from "./accounts/customers/List";
import { List as SessionsList } from "./accounts/sessions/List";
import { Edit as AccountsUserBrandsEdit } from "./accounts/userBrands/Edit";
import { List as AccountsUserBrandsList } from "./accounts/userBrands/List";
import { New as AccountsUserBrandsNew } from "./accounts/userBrands/New";
import { Show as AccountsUserBrandsShow } from "./accounts/userBrands/Show";
import { Edit as AccountsUsersEdit } from "./accounts/users/Edit";
import { List as AccountsUsersList } from "./accounts/users/List";
import { New as AccountsUsersNew } from "./accounts/users/New";
import { Show as AccountsUsersShow } from "./accounts/users/Show";
import { Show as ArticlesItemsDetailsShow } from "./articles/items/details/Show";
import { Edit as ArticlesItemsEdit } from "./articles/items/Edit";
import { Edit as ArticlesItemsImagesEdit } from "./articles/items/images/Edit";
import { List as ArticlesItemsImagesList } from "./articles/items/images/List";
import { List as ArticlesItemsList } from "./articles/items/List";
import { New as ArticlesItemsNew } from "./articles/items/New";
import { Edit as ArticlesItemsPricesEdit } from "./articles/items/prices/Edit";
import { List as ArticlesItemsPricesList } from "./articles/items/prices/List";
import { New as ArticlesItemsPricesNew } from "./articles/items/prices/New";
import { Show as ArticlesItemsShow } from "./articles/items/Show";
import { List as ArticlesItemsStocksList } from "./articles/items/stocks/List";
import { Edit as ArticlesItemsSuggestionsEdit } from "./articles/items/suggestions/Edit";
import { List as ArticlesItemsSuggestionsList } from "./articles/items/suggestions/List";
import { List as ArticlesItemsVariantsList } from "./articles/items/variants/List";
import { New as ArticlesItemsVariantsNew } from "./articles/items/variants/New";
import { Dash as AttributesDash } from "./attributes/Dash";
import { CompletePasswordReset as AuthCompletePasswordReset } from "./auth/CompletePasswordReset";
import { RequestPasswordReset as AuthRequestPasswordReset } from "./auth/RequestPasswordReset";
import { SignIn as AuthSignIn } from "./auth/SignIn";
import { Edit as BrandsEdit } from "./brands/Edit";
import { List as BrandsList } from "./brands/List";
import { New as BrandsNew } from "./brands/New";
import { Edit as ColorGroupsEdit } from "./color_groups/Edit";
import { List as ColorGroupsList } from "./color_groups/List";
import { New as ColorGroupsNew } from "./color_groups/New";
import { Edit as ColorsEdit } from "./colors/Edit";
import { List as ColorsList } from "./colors/List";
import { New as ColorsNew } from "./colors/New";
import { Edit as CompositionGroupsEdit } from "./composition_groups/Edit";
import { List as CompositionGroupsList } from "./composition_groups/List";
import { New as CompositionGroupsNew } from "./composition_groups/New";
import { Edit as CompositionsEdit } from "./compositions/Edit";
import { List as CompositionsList } from "./compositions/List";
import { New as CompositionsNew } from "./compositions/New";
import { Edit as FittingsEdit } from "./fittings/Edit";
import { List as FittingsList } from "./fittings/List";
import { New as FittingsNew } from "./fittings/New";
import { Edit as KindGroupsEdit } from "./kind_groups/Edit";
import { List as KindGroupsList } from "./kind_groups/List";
import { New as KindGroupsNew } from "./kind_groups/New";
import { Edit as KindsEdit } from "./kinds/Edit";
import { List as KindsList } from "./kinds/List";
import { New as KindsNew } from "./kinds/New";
import { Edit as LinesEdit } from "./lines/Edit";
import { List as LinesList } from "./lines/List";
import { New as LinesNew } from "./lines/New";
import { Show as LinesShow } from "./lines/Show";
import { List as OrdersCartsList } from "./orders/carts/List";
import { Show as OrdersCartsShow } from "./orders/carts/Show";
import { List as OrdersDocumentsList } from "./orders/documents/List";
import { Show as OrdersDocumentsShow } from "./orders/documents/Show";
import { Edit as PriceListsEdit } from "./price_lists/Edit";
import { List as PriceListsList } from "./price_lists/List";
import { New as PriceListsNew } from "./price_lists/New";
import { Edit as SeasonsEdit } from "./seasons/Edit";
import { List as SeasonsList } from "./seasons/List";
import { New as SeasonsNew } from "./seasons/New";
import { Show as SeasonsShow } from "./seasons/Show";
import { Edit as SizeGroupsEdit } from "./size_groups/Edit";
import { List as SizeGroupsList } from "./size_groups/List";
import { New as SizeGroupsNew } from "./size_groups/New";
import { Edit as SizesEdit } from "./sizes/Edit";
import { List as SizesList } from "./sizes/List";
import { New as SizesNew } from "./sizes/New";
import { Dash as StatsDash } from "./stats/Dash";
import { EditStocks } from "./stocks/EditStocks";
import { List as StocksList } from "./stocks/List";

const frames = {
  AuthCompletePasswordReset,
  AuthRequestPasswordReset,
  AuthSignIn,

  StatsDash,

  AccountsCustomersList,

  AccountsUserBrandsList,
  AccountsUserBrandsShow,
  AccountsUserBrandsNew,
  AccountsUserBrandsEdit,

  AccountsUsersList,
  AccountsUsersShow,
  AccountsUsersNew,
  AccountsUsersEdit,

  ArticlesItemsList,
  ArticlesItemsShow,
  ArticlesItemsEdit,
  ArticlesItemsNew,
  ArticlesItemsVariantsNew,

  ArticlesItemsDetailsShow,

  ArticlesItemsImagesList,
  ArticlesItemsImagesEdit,

  ArticlesItemsPricesList,
  ArticlesItemsPricesNew,
  ArticlesItemsPricesEdit,

  ArticlesItemsSuggestionsList,
  ArticlesItemsSuggestionsEdit,
  ArticlesItemsVariantsList,

  ArticlesItemsStocksList,

  OrdersDocumentsList,
  OrdersDocumentsShow,

  OrdersCartsList,
  OrdersCartsShow,

  StocksList,
  EditStocks,

  BrandsList,
  BrandsEdit,
  BrandsNew,

  SeasonsList,
  SeasonsEdit,
  SeasonsShow,
  SeasonsNew,

  LinesList,
  LinesEdit,
  LinesShow,
  LinesNew,

  AttributesDash,

  SizeGroupsList,
  SizeGroupsNew,
  SizeGroupsEdit,

  SizesList,
  SizesNew,
  SizesEdit,

  CompositionGroupsList,
  CompositionGroupsNew,
  CompositionGroupsEdit,

  CompositionsList,
  CompositionsNew,
  CompositionsEdit,

  ColorGroupsList,
  ColorGroupsNew,
  ColorGroupsEdit,

  ColorsList,
  ColorsNew,
  ColorsEdit,

  KindGroupsList,
  KindGroupsNew,
  KindGroupsEdit,

  KindsList,
  KindsNew,
  KindsEdit,

  PriceListsList,
  PriceListsNew,
  PriceListsEdit,

  FittingsList,
  FittingsNew,
  FittingsEdit,

  SessionsList,
};

export default frames;
